import Api from "./Api";
import { API_VERSION } from "@/config/index";

export default {
  GetMovies(payload) {
    return Api().post(`/${API_VERSION}/webapp/movies`, payload);
  },
  GetMovie(payload) {
    return Api().get(`/${API_VERSION}/webapp/movies/${payload.movie_code}`);
  },
  GetHomepageMovies(payload) {
    return Api().get(`/${API_VERSION}/webapp/homepagemovies`);
  },
  GetMoviesByCinema(payload) {
    return Api().get(
      `/${API_VERSION}/webapp/moviesbycinema/${payload.cinema_code}`
    );
  },
  SearchMovies(payload) {
    return Api().get(`/${API_VERSION}/webapp/movies/search/${payload.search}`);
  },
  NowShowingMovies(payload) {
    return Api().post(`/${API_VERSION}/webapp/now-showing`, payload);
  },
  ComingSoonMovies(payload) {
    return Api().get(`/${API_VERSION}/webapp/coming-soon`);
  },
  LikeMovie(payload) {
    return Api().put(`/${API_VERSION}/webapp/like-movie/${payload.movie_code}`);
  },
  GetMovieLanguages(payload) {
    return Api().get(`/${API_VERSION}/webapp/movie/languages`);
  },
  GetMovieGenres(payload) {
    return Api().get(`/${API_VERSION}/webapp/movie/genres`);
  }
};



// WEBPACK FOOTER //
// ./src/apiServices/MovieService.js